import http from '../../../plugins/axios';

export default {

    alterCryptoSwitch(data) {
        return http.post({
            url: '/admin/crypto/switch/alter',
            data,
            dataType: 'form'
        })
    },

    queryCryptoSwitch() {
        return http.get({
            url: '/admin/crypto/switch/query',
        })
    },
}